<template>
  <div
    class="fixed top-0 left-0 w-full h-screen bg-gray-400/70 flex items-center justify-center"
    role="alert"
    aria-busy="true"
  >
    <div class="w-28 h-28 spinner border-l-teal-blue animate-spin"></div>
  </div>
</template>

<style scoped>
.spinner {
  border: 10px solid rgba(0, 0, 0, 0);
  border-radius: 50%;
  border-left-color: var(--teal-blue);
  border-right-color: var(--teal-blue);
}
</style>
